import React, {useContext, useEffect, useState} from "react";
import {Cookies, useCookies} from "react-cookie";
import {useNavigate} from "react-router-dom";
import {useSanctum} from "react-sanctum";
import {useToolkit} from './useToolkit';
import { v4 as uuidv4 } from 'uuid';
import {emailStorage} from "../config/global";

export const useEmailStorage = () => {

    function setEmailStorageSent() {
        sessionStorage.setItem(emailStorage.emailSent, JSON.stringify(true));
    }
    function removeEmailStorageSent() {
        sessionStorage.removeItem(emailStorage.emailSent);
    }
    function getEmailStorageSent() : string | null {
        var k = sessionStorage.getItem(emailStorage.emailSent);
        if(k)
            return JSON.parse(k);
        else
            return null;
    }

    const emailStorageSent = JSON.parse(getEmailStorageSent() || 'false') as boolean;


    return {
        setEmailStorageSent,
        removeEmailStorageSent,

        //getEmailStorageSent,
        emailStorageSent
    }
};
